import React from "react";

// Public privacy policy page for the Doserne Academy app (web + iOS + Android).
// Used as the "Privacy Policy URL" in App Store Connect and Google Play Console.
// Doserne Academy is an internal tool for a small team of Doserne AS employees.
export default function PrivacyPolicy() {
  const updated = "June 11, 2026";
  return (
    <div className="min-h-screen bg-white text-slate-800" data-testid="privacy-policy-page">
      <div className="max-w-3xl mx-auto px-5 py-12">
        <h1 className="text-3xl font-bold text-slate-900">Privacy Policy</h1>
        <p className="mt-2 text-sm text-slate-500">Doserne Academy · Last updated {updated}</p>

        <section className="mt-8 space-y-3">
          <p>
            Doserne Academy is an internal work tool built for a limited number of employees at
            Doserne AS. The app is not intended for the general public. This policy describes what
            information we process and why.
          </p>
          <p><strong>Data controller:</strong> Doserne AS.</p>
          <p><strong>Contact:</strong> support@allstillas.no</p>
        </section>

        <h2 className="mt-8 text-xl font-semibold text-slate-900">Information we process</h2>
        <ul className="mt-3 list-disc pl-6 space-y-2">
          <li><strong>Account information:</strong> name, phone number and email (accounts are created by an administrator).</li>
          <li><strong>Messages and photos:</strong> chat messages, voice messages and images you share in the app.</li>
          <li><strong>Calls:</strong> audio/video during calls (relayed in real time, not stored) and a call log.</li>
          <li><strong>Camera and microphone:</strong> used only during calls and for photos/uploads you initiate yourself.</li>
          <li><strong>Notifications:</strong> a device token so we can send push notifications.</li>
          <li><strong>Technical info:</strong> device type and app version for troubleshooting.</li>
        </ul>

        <h2 className="mt-8 text-xl font-semibold text-slate-900">Why we process it</h2>
        <p className="mt-3">
          Only to operate the internal tool: sign-in, messaging, calls, project and time tracking,
          courses and notifications. We do <strong>not</strong> use the information for advertising,
          and we <strong>do not sell</strong> it to anyone.
        </p>

        <h2 className="mt-8 text-xl font-semibold text-slate-900">Sharing with third parties</h2>
        <ul className="mt-3 list-disc pl-6 space-y-2">
          <li><strong>LiveKit</strong> – real-time audio/video for calls.</li>
          <li><strong>Apple (APNs) / Google (FCM)</strong> – delivery of push notifications.</li>
          <li>Secure cloud storage for uploaded files/images.</li>
        </ul>
        <p className="mt-3">These providers only receive what is necessary to deliver the service.</p>

        <h2 className="mt-8 text-xl font-semibold text-slate-900">Retention</h2>
        <p className="mt-3">
          Information is stored for as long as you are an active user. Call audio/video is not stored.
        </p>

        <h2 className="mt-8 text-xl font-semibold text-slate-900">Your rights (GDPR)</h2>
        <p className="mt-3">
          You have the right to access, correct and delete your information, and to withdraw
          permissions (camera, microphone, notifications) in your device settings. For access or
          <strong> deletion of your account and data</strong>, contact <strong>support@allstillas.no</strong>.
        </p>

        <h2 className="mt-8 text-xl font-semibold text-slate-900">Children</h2>
        <p className="mt-3">The app is for employees only and is not directed at children.</p>

        <h2 className="mt-8 text-xl font-semibold text-slate-900">Changes</h2>
        <p className="mt-3">
          We may update this policy. Significant changes will be announced in the app.
        </p>

        <p className="mt-10 text-sm text-slate-500">
          Questions? Contact us at support@allstillas.no.
        </p>
      </div>
    </div>
  );
}
